import { collection, doc, getDoc, where } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const GetSingleAgent = async (agentId, bid) => {
  /*
   * input: null
   * output: agent object
   * description: fetches Single agent
   */
  bid = bid || getLocalStorageItem("bid");
  try {
    const clientsDocument = await doc(db, "clients", bid);
    const agentCollection = await collection(clientsDocument, "agents");
    const agentDocument = await doc(agentCollection, agentId);
    const agentSnapshot = await getDoc(
      agentDocument,
      where("bid", "==", getLocalStorageItem("bid")),
      where("is_deleted", "==", false)
    );

    const agent = { id: agentSnapshot.id, ...agentSnapshot.data() };
    return agent;
  } catch (error) {
    console.log(error);
  }
};

export default GetSingleAgent;
